import { render, staticRenderFns } from "./rel-receita.vue?vue&type=template&id=50d41c82&scoped=true&"
import script from "./rel-receita.vue?vue&type=script&lang=js&"
export * from "./rel-receita.vue?vue&type=script&lang=js&"
import style0 from "./rel-receita.vue?vue&type=style&index=0&id=50d41c82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d41c82",
  null
  
)

export default component.exports